import Page from "flarum/common/components/Page";
import { urls } from "@speareducation/util";

export default class BecomeAMember extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loginLink = `${urls.getBaseUrl("accounts")}/login?redirect=${urls.getBaseUrl("community")}${m.route.param("redirect")}`;
    this.imgLink = `${urls.getAssetsBaseUrl()}/community/become-a-member.jpeg`;
  }

  view() {
    return (
      <section className="BecomeAMember-page">
        <h1 className="title">
          Join the largest members-only community for dental professionals.
        </h1>

        <div className="subtitle">
          Already a Member?
          <a id="login-link" href={this.loginLink} className="login-link">
            Login to Spear
          </a>
        </div>

        <div className="page-container">
          <div className="column image-container">
            <div className="image-wrapper">
              <img
                src={this.imgLink}
                alt="Person uses Spear Talk app on a phone"
              />
            </div>
          </div>

          <div className="column cta-content">
            <h3 className="cta-headline">Become a Member</h3>
            <div className="cta-body">
              Never feel alone in your clinical and practice management
              challenges.
            </div>
            <div className="cta-body">
              Spear offers a rewarding community of Faculty and your peers.
            </div>
            <div>
              <a
                href={`${urls.getBaseUrl("www")}/spear-online`}
                className="cta"
              >
                Why Join?
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
